import { useTour } from '@reactour/tour';
import { useEffect } from 'react';
import { isANumber } from '../../utils/number';
import { appDispatch, RootState } from '../../store/store';
import { setAddOrUpdateUserFlag } from '../../store/thisUser/thisUserSlice';
import { useSelector } from 'react-redux';

interface IProps {
  children: React.ReactNode;
}

interface IStepList {
  selector: string;
  content: string;
  category: string;
}

export function addTourStep(
  setSteps: any,
  stepList: IStepList[],
  addFirst: boolean = false
) {
  if (addFirst) {
    setSteps?.((prevState: any) => [
      ...(stepList || []),
      ...(prevState || []).filter(
        (it: any) =>
          !(stepList || []).find(
            (v: any) => v.category === (it as any).category
          )
      ),
    ]);
  } else {
    setSteps?.((prevState: any) => [
      ...(prevState || []).filter(
        (it: any) =>
          !(stepList || []).find(
            (v: any) => v.category === (it as any).category
          )
      ),
      ...(stepList || []),
    ]);
  }
}

const TourWrapper: React.FC<IProps> = ({ children }) => {
  const { steps, currentStep, isOpen, setIsOpen, setSteps } = useTour();
  const isValidUser = useSelector((state: RootState) => state.thisUser.userId);

  useEffect(() => {
    if (!isValidUser) {
      setSteps?.([]);
      return;
    }

    if (!isOpen && isANumber(currentStep) && steps.length) {
      const stepIndex = Array.from({ length: currentStep + 1 }, (_, i) => i);
      for (const index of stepIndex) {
        const request = async () => {
          await appDispatch(
            setAddOrUpdateUserFlag({
              flagName: (steps[index] as any).category!,
              flagValue: 'true',
              flagGroup: 'tour',
            })
          );
        };
        request();
      }
      setSteps?.([]);
    }
  }, [isOpen, setIsOpen, isValidUser]);

  return <>{children}</>;
};

export default TourWrapper;
